  enum Mode {
    NETWORKING = 'Break/Networking Mode' ,
    INSTRUCTOR = 'Instructor Mode' ,
    ACTIVITY = 'Activity Mode'
 } 


 export default Mode;
